"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortArrayByKeyValue = sortArrayByKeyValue;
exports.randomIdGenerator = randomIdGenerator;
function sortArrayByKeyValue(data, key, value) {
    return data.sort(function (x, y) {
        return x[key] !== value ? 0 : y[key] !== value ? -1 : 1;
    });
}
function randomIdGenerator(length) {
    try {
        let result = "";
        const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }
    catch (error) {
        return "health";
    }
}
